import * as moment from "moment";
import {Currency} from "./currencies";
import { ILocation } from "./location";

export interface IBulkConfig {
    regions: {
        region: string;
        sources: {
            source: string;
            available_formats: string[];
            example?: string;
        }[]
    }[]
}

export interface IBulkDryRunResult {
    date: moment.Moment;
    currency: Currency;
    amount: number;
    description: string;
    errors: string[] | null;
    paymentMethod?: string;
    categoryId: number | null;
    location?: ILocation | null;
}

export interface IBulkFormData extends IBulkDryRunResult {
    isDeleted?: boolean;
}


export enum Source {
    DE_AMAZON_VISA = 'de_amazon_visa',
    DE_AMAZON_VISA_ZINIA = 'de_amazon_visa_zinia',
    DE_AMEX = 'de_amex',
    DE_DKB = 'de_dkb',
    DE_N26 = 'de_n26',
    GLOBAL_EXPENSES_24 = 'global_es',
}
